export default __webpack_public_path__ + "static/media/GO.7b553953.svg";